module.exports = __webpack_public_path__ + "media/Langkah Sheraton Video 01.08521b99.mp4";